module.exports = __webpack_public_path__ + "img/ic_dph.b6f734cf.png";